import React, { Component } from 'react';
import { Field } from 'redux-form'
import { FormGroup, ModalHeader, Button, ModalBody, Label, Nav, NavItem, NavLink, Row, Col, Popover, PopoverBody ,Input} from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { TextInput, SelectInput, DateInput,NumberInput,AmountInput, DisplayPayBtnText} from 'components/Common';
import FDConfig from 'lib/config';
import { dateToFPDateStr, fpDateStrToDate, onlyNumberAndDot,email, onDropAlphawithsinglespace,isValidDate,siValidDate ,numberOnly,avoidPasting} from 'lib/fp-utility';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class EMICardDetail extends Component {

	toggleDebitAmt = this.toggleDebitAmt.bind(this)
	togglePopover = this.togglePopover.bind(this)
	closePopover = this.closePopover.bind(this)
	checkDatePresent = this.checkDatePresent.bind(this)
	clearEndDate = this.clearEndDate.bind(this)
	checkEndDate = this.checkEndDate.bind(this)
	checkFrequency = this.checkFrequency.bind(this)
	handleMinEndDate = this.handleMinEndDate.bind(this)

	state = {
		duration: false, 
		amountType: false, 
		startDate: null, 
		endDate: null,
		value: '',
		isInputValid: true,
		errorMessage: '',
		disableEndDate: false,
		disableStartDate: false,
		standingInstructionBean:null,
		autoDebit:null,
		frequencyValue:null,
		sIAmtType:"fixed",
		siAmount:"",
		disableDate:false,
		disablesIFrequency: false

	}

	componentWillUnmount(){
		this.props.change('siModal', false)
	}

	componentDidMount(){
		const {transactionDetails:{standingInstructionBean,autoDebit}  } = this.props;
		this.setState({standingInstructionBean:standingInstructionBean});

		this.props.change('siModal', true) // Trigger validation
		/* Reset SI fields */
		this.props.change('standingInst[sIFrequency]', null)
		this.props.change('standingInst[sIStartDate]', null)
		this.props.change('standingInst[sIEndDate]', null)
		this.props.change('standingInst[sIAmtType]', "fixed")
		this.props.change('standingInst[sihubBean][siAmount]', null)
		this.props.untouch('standingInst[sIFrequency]')
		this.props.untouch('standingInst[sIStartDate]')
		this.props.untouch('standingInst[sIEndDate]')
		this.props.untouch('standingInst[sIAmtType]')
		this.props.untouch('standingInst[sihubBean][siAmount]')
		this.setState({frequencyValue:null,startDate: null, endDate: null,standingInstructionBean:standingInstructionBean,autoDebit:autoDebit},()=>{
			if(this.state.autoDebit === "Y" ){
				this.setEMIDuration();
				this.setSIAmtType();
				if(standingInstructionBean){
					const startDate = siValidDate(standingInstructionBean.sIStartDate);
					const endDate = siValidDate(standingInstructionBean.sIEndDate);
					this.props.change("standingInst[sihubBean]", standingInstructionBean.sihubBean)

					if(isValidDate(endDate)){
						const endDateS = new Date(endDate);
						this.setState({
							endDate:endDateS,
							disableEndDate: true
						})
						this.props.change("standingInst[sIEndDate]", standingInstructionBean.sIEndDate)						
					}

					if(isValidDate(startDate)){
						const startDateS= new Date(startDate);
						this.setState({
							startDate:startDateS,
							disableStartDate:true,
						})
						this.props.change("standingInst[sIStartDate]", standingInstructionBean.sIStartDate)
					}
					if(standingInstructionBean.sIAmtType){
						this.setState({
							disableDate:true,
						})
					}
					// if(standingInstructionBean && isValidDate(endDate) && isValidDate(startDate) ){
					// 	const startDateS= new Date(startDate);
					// 	const endDateS = new Date(endDate);
					// 	this.setState({
					// 		startDate:startDateS,
					// 		endDate:endDateS,
					// 		disableStartDate:startDateS ? true: false,
					// 		disableEndDate: endDateS ? true : false
					// 	})
					// 	this.props.change("standingInst[sIStartDate]", standingInstructionBean.sIStartDate)
					// 	this.props.change("standingInst[sIEndDate]", standingInstructionBean.sIEndDate)
					// 	this.props.change("standingInst[sihubBean]", standingInstructionBean.sihubBean)
						
					// }else{
					// 	this.setState({disableDate:false})
					// }
				}
				
			}

		})
		
	}
	
	toggleDebitAmt(amtType){
		if(!this.state.disableDate){
			this.props.change('standingInst[sIAmtType]',amtType)
			this.setState({sIAmtType:amtType})
			if(amtType==='fixed'){
				this.props.change('standingInst[sihubBean][siAmount]', this.props.transactionDetails.amount)
				this.props.untouch('standingInst[sihubBean][siAmount]')
			}else{
				this.props.change('standingInst[sihubBean][siAmount]', null)
			}
		}
	}

	togglePopover(type) {
		if(type==="duration"){
            this.setState({duration: true, amountType: false});
        }else if(type === "amountType") {
            this.setState({duration: false, amountType: true});
        } 
	}

	closePopover(e){
		this.setState({duration: false, amountType: false});
	}

	checkDatePresent(type, e){
		const date = e.target.value
		if(type==="start"){
			this.setState({inValidStartDate: date===""})
		}else if(type==="end"){
			this.setState({inValidEndDate: date===""})
		}
	}

	clearEndDate(date){
		this.setState({disableEndDate: false})
		this.props.change('standingInst[sIEndDate]', null)
		this.setState({endDate: null})

		const selectedDate = Date.parse(date)
		let currentDate = new Date();
		currentDate.setHours(0,0,0,0);
		/* Selected date should be current and future and End date should be greater than Start date */
		if(selectedDate && currentDate <= selectedDate){
			let formatted_date = dateToFPDateStr(date)
			this.setState({startDate: date, inValidStartDate: false});
			this.props.change("standingInst[sIStartDate]", formatted_date)
		}
	}

	checkEndDate(date){
		const minEndDate = this.handleMinEndDate()
		const minEndDateInt = Date.parse(minEndDate)
		const selectedEndDateInt = Date.parse(date)
		if(minEndDateInt<=selectedEndDateInt){
			let formatted_date = dateToFPDateStr(date)
			this.setState({endDate: date, inValidEndDate: false});
			this.props.change("standingInst[sIEndDate]", formatted_date)
		}else{
			this.setState({inValidEndDate: true, });
		}
	}

	checkFrequency(value){
		//if(!this.state.disableDate ){
			this.setState({ frequencyValue : value});
			//this.props.change('standingInst[sIEndDate]', null)
			this.props.change('standingInst[sIFrequency]',value)
			//this.setState({endDate: null})
			
			// if(value){
			// 	const inputSDate = document.getElementById('startDate').value
			// 	this.setState({disableStartDate: false, disableEndDate: inputSDate===''})
			// }else{
			// 	this.setState({disableStartDate: true, disableEndDate: true})
			// }
		//}
		
	}

	handleMinEndDate(){
		if(this.props.formValues && this.props.formValues.standingInst){
			const { sIStartDate, sIFrequency } = this.props.formValues.standingInst
			if(sIStartDate && sIFrequency && (sIFrequency === "week" || sIFrequency === "bimn")){
				const startDate = fpDateStrToDate(sIStartDate)
				const minEndDate = new Date(startDate.setDate(startDate.getDate()+parseInt(this.getSIFrequencyValue(sIFrequency))));
				return minEndDate
			}else if(sIStartDate && sIFrequency && sIFrequency !== "adho"   ){
				const startDate = fpDateStrToDate(sIStartDate)
				const minEndDate = new Date(startDate.setMonth(startDate.getMonth()+parseInt(this.getSIFrequencyValue(sIFrequency))));
				return minEndDate
			}
			else{
				return new Date()
			}
		}
	}

	getSIFrequencyValue(sIFrequency){
		const si = {"week":"7", "mnth":"1", "qurt":"3", "bimn":"15", "year":"12" ,"bian":"6" }
		return si[sIFrequency]
	}

	setEMIDuration(){
			// const {} = SIBean;
			const {standingInstructionBean,autoDebit} = this.state;
			if(standingInstructionBean && standingInstructionBean.sIFrequency && autoDebit === "Y"){
				/* const selectedFrequency = FDConfig.standingInstruction.frequency.filter((value,index) => {
					if(value && value.displayName && standingInstructionBean.sIFrequency && standingInstructionBean){
						return value.displayName.toString().toUpperCase() === standingInstructionBean.sIFrequency.toString().toUpperCase()
					}
					
				})
				this.setState({ frequencyValue : selectedFrequency[0].value});
				this.props.change('standingInst[sIFrequency]', selectedFrequency[0].value) */
				this.setState({ frequencyValue : standingInstructionBean.sIFrequency, disablesIFrequency: true});
				this.props.change('standingInst[sIFrequency]', standingInstructionBean.sIFrequency)
			}
			
			
	}

	setSIAmtType(){
		const {standingInstructionBean,autoDebit} = this.state;
		if(standingInstructionBean && standingInstructionBean.sIFrequency && autoDebit === "Y"){
			/* const selectedAmtType = FDConfig.standingInstruction.amountType.filter((value,index) => {
				if(value && value.displayName && standingInstructionBean.sIAmtType && standingInstructionBean){
					return value.displayName.toString().toUpperCase() === standingInstructionBean.sIAmtType.toString().toUpperCase()
				}
				
			})
			this.setState({ sIAmtType : selectedAmtType[0].value},()=>{
				if( selectedAmtType[0].value ==='Variable'){
					this.setState({maxDebitAmt:standingInstructionBean.maxDebitAmt})
					this.props.change('standingInst[sIAmtType]', selectedAmtType[0].value);
					this.props.change('standingInst[maxDebitAmt]', standingInstructionBean.maxDebitAmt);
				}else{
					this.setState({maxDebitAmt:null});
					this.props.change('standingInst[sIAmtType]', selectedAmtType[0].value);
					this.props.change('standingInst[maxDebitAmt]',null);
				}
			}); */
			this.setState({ sIAmtType :  standingInstructionBean.sIAmtType},()=>{
				
					if(  standingInstructionBean.sIAmtType){
						
						
						this.props.change('standingInst[sIAmtType]', standingInstructionBean.sIAmtType);
						if(standingInstructionBean.sihubBean && standingInstructionBean.sihubBean.siAmount){
							this.props.change('standingInst[sihubBean][siAmount]', standingInstructionBean.sihubBean.siAmount);
							this.setState({siAmount:standingInstructionBean.sihubBean.siAmount});
						}else{
							this.props.change('standingInst[sihubBean][siAmount]', this.props.transactionDetails.amount);
							this.setState({siAmount:this.props.transactionDetails.amount});
							
						}
					}else{
						this.setState({siAmount:null});
						this.props.change('standingInst[sIAmtType]', standingInstructionBean.sIAmtType);
						this.props.change('standingInst[sihubBean][siAmount]',null);
					}
				
				
			});
		}
	}

    render() {
		const { submitDisabled, t, transactionDetails } = this.props;
		const {frequencyValue,sIAmtType,siAmount,standingInstructionBean} = this.state;
		const disableInput = standingInstructionBean  ? true:false
        return (
            <>
				{/* <ModalHeader toggle={this.props.toggleStandingInst}>{t('stand_instruction_title')}</ModalHeader> */}
				<div>
					{/* <h6 className="text-18">{t('select_duration')}
						<span id='popover1' className="icon-info "></span>
					</h6> */}
					<Row>
						<Col md="12">
						<Field name="siModal" type="hidden" component='input' /> {/* This field just to trigger form validation */}
						<Field name="standingInst[sIStartDate]" type="hidden" component='input' />
						<Field name="standingInst[sIEndDate]" type="hidden" component='input' />
						{/* <FormGroup className="custom-dd">
							<Field setDisabled={disableInput} selectValue={frequencyValue} name="standingInst[sIFrequency]" component={SelectInput} 
							options={FDConfig.standingInstruction.frequency} 
							className='form-control' blank='Select the duration' id="siFrequency"
							 onChange={this.checkFrequency} />
						</FormGroup> */}
						</Col>
						<Col md="12" className="mb-3">
						<Row>
						<Col className="col-4">
							<input id ="weekly" disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() => this.checkFrequency("week")}  name="standingInst[sIFrequency]" checked={frequencyValue === "week" }></input>
							<label htmlFor="weekly">Weekly</label>
						</Col>
						<Col className="col-4">
							<input id ="monthly" disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() => this.checkFrequency("mnth")}  name="standingInst[sIFrequency]" checked={frequencyValue === "mnth" }></input>
							<label htmlFor="monthly">Monthly</label>
						</Col>
						<Col className="col-4">
							<input id ="bi-weekly"  disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() => this.checkFrequency("bimn")}  name="standingInst[sIFrequency]" checked={frequencyValue === "bimn" }></input>
							<label htmlFor="bi-weekly">Bi-Monthly</label>
						</Col>
						</Row>
						<Row>
						<Col className="col-4">
							<input id="quarterly" disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() => this.checkFrequency("qurt")} name="standingInst[sIFrequency]" checked={frequencyValue === "qurt"}></input>
							<label htmlFor="quarterly">Quarterly</label>
						</Col>	
						<Col className="col-4">
							<input id="six-monthly" disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() => this.checkFrequency("bian")} name="standingInst[sIFrequency]" checked={frequencyValue === "bian"}></input>
							<label htmlFor="six-monthly">Six-Monthly</label>
						</Col>
						<Col className="col-4">
							<input id="yearly" disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() =>  this.checkFrequency("year")} name="standingInst[sIFrequency]" checked={frequencyValue === "year"}></input>
							<label htmlFor="yearly">Yearly</label>
						</Col>
						</Row>
						<Row>
						<Col className="col-4">
							<input id="adho" disabled={this.state.disablesIFrequency} className='form-control' type="radio" onChange={() => null} onClick={() =>  this.checkFrequency("adho")} name="standingInst[sIFrequency]" checked={frequencyValue === "adho"}></input>
							<label htmlFor="adho">Adhoc</label>
						</Col>
						</Row>
						</Col>

						<Col md="6" xs="6">
							<FormGroup className="max-130 customDatePicker">
								<DatePicker 
									id='startDate'
									customInput={
										<DateInput
											hasError={this.state.inValidStartDate}
											from='startDate'
											errorMessage="Invalid Start Date"
											disableDate={this.state.disableStartDate}
											/>
										}
									placeholderText="Start Date*" 
									dateFormat="dd/MM/yyyy"
									autoComplete="off"
									selected={this.state.startDate}
									showMonthDropdown
									showYearDropdown
									startDate={this.state.startDate}
									minDate={new Date()}
									onBlur={(e) => this.checkDatePresent('start',e)}
									onChange={(e) => this.clearEndDate(e)}
									autoOk={true} 
								/>
								
							</FormGroup>
						</Col>
						<Col md="6" xs="6">
							<FormGroup className="max-130 customDatePicker">
								<DatePicker 
									id='endDate'
									customInput={
										<DateInput 
											hasError={this.state.inValidEndDate}
											errorMessage="Invalid End Date"
											from='endDate'
											disableDate={this.state.disableEndDate}
										/>
									}
									autoComplete="off"
									placeholderText="End Date*"
									dateFormat="dd/MM/yyyy" 
									selected={this.state.endDate}
									showMonthDropdown
									showYearDropdown
									minDate={this.handleMinEndDate()}
									onBlur={(e) => this.checkDatePresent('end',e)}
									onChange={(e) => this.checkEndDate(e)}
									autoOk={true} 
								/>
									{/* <span className="icon-calendar"></span> */}
							</FormGroup>
						</Col>
					</Row>

					{/* <div className="note-popup hidden-mob">
                        <Label>{t('Note')}:</Label>
                        <Nav>
							{t('duration_option', {returnObjects: true}).map(({duration}, i) => (
								<NavItem key={i}>{duration}</NavItem>
							))}
                        </Nav>
                    </div> */}

					{/* <Popover className="" target='popover1' placement="bottom" isOpen={this.state.duration}  toggle={()=>this.togglePopover('duration')}>
						<PopoverBody>
							
						<div className="note-popup">
                        <Label>{t('Note')}: <span className="btn-closed icon-close" onClick={this.closePopover}></span></Label>
                        <Nav>
							{t('duration_option', {returnObjects: true}).map(({duration},i) => (
								<NavItem key={i}>{duration}</NavItem>
							))}
                        </Nav>
                    	</div>
						</PopoverBody>
					</Popover> */}

					<hr className="hidden-mob"/>

					{/* <h6 className="text-18">{t('amount_type')}
						<span id="popover2" className="icon-info "></span>
					</h6> */}
						<Row>
							{/* <Col md="12">
								<FormGroup className="custom-dd">
									<Field selectValue={sIAmtType}  setDisabled={disableInput} onChange={(e)=>this.toggleDebitAmt(e.target.value)} 
									name="standingInst[sIAmtType]" component={SelectInput} 
									options={FDConfig.standingInstruction.amountType} 
									className='form-control' blank='Select the amount type'/> 
								</FormGroup>
							</Col> */}
							<Col className="mb-3">
						
							<input  id ="maximum" className='form-control' type="radio"  onChange={() => null} onClick={() => this.toggleDebitAmt("maximum")}  name="standingInst[sIAmtType]" checked={sIAmtType === "maximum"}></input>
									<label htmlFor="maximum">Maximum</label>
							<input  id="fixed" className='form-control' type="radio"   onChange={() => null} onClick={() => this.toggleDebitAmt("fixed")} name="standingInst[sIAmtType]" checked={sIAmtType === "fixed"}></input>
									<label htmlFor="fixed">Fixed</label>
							</Col>
							{
								(sIAmtType==='maximum' || sIAmtType==='fixed')  &&
								<Col className="custom-max130" md="12">
									<Field
										name="standingInst[sihubBean][siAmount]"
										id="siAmount"
										component={AmountInput}
										setDisabled={disableInput}
										placeholder="Debit Amount"
										parentClassName="max-130"
										defaultValue={siAmount}
										onChange={(e) => this.setState({siAmount:e.target.value})}
										onDrop={onDropAlphawithsinglespace}
										normalize={(value, preVal) => numberOnly(value, preVal)}
										currencyCode={t(transactionDetails.currencyCode)}
										// format = {(value, preVal) => numberOnly(value, preVal)} 
										// normalize={(value, preVal) => email(value, preVal)} 
									/>
								</Col>
							}
						</Row>
						<Row>
						<Col className="custom-max130" md="12">
							<Field
								name="standingInst[sihubBean][custEmailId]"
								id="Email"
								component={TextInput}
								setDisabled={(transactionDetails.standingInstructionBean && transactionDetails.standingInstructionBean.sihubBean  && transactionDetails.standingInstructionBean.sihubBean.custEmailId) ? true : false}
								placeholder="Email*"
								parentClassName="max-130"
								onDrop={onDropAlphawithsinglespace}
								defaultValue={(transactionDetails.standingInstructionBean && transactionDetails.standingInstructionBean.sihubBean  && transactionDetails.standingInstructionBean.sihubBean.custEmailId) ? transactionDetails.standingInstructionBean.sihubBean.custEmailId : ''}
								// normalize={(value) => onlyNumberAndDot(value)} 
							/>
						</Col>
						</Row>
						<Row>
						<Col className="custom-max130" md="12">
							<Field
								name="standingInst[sihubBean][nickname]"
								id="Nickname"
								component={TextInput}
								placeholder="Nick name"
								parentClassName="max-130"
								onDrop={onDropAlphawithsinglespace}
								// normalize={(value) => onlyNumberAndDot(value)} 
							/>
						</Col>
						</Row>
						{/* <div className="note-popup p-0 hidden-mob">
                        <Label>{t('Note')}:</Label>
						<Nav>
							{t('type_note', {returnObjects: true}).map(({option}, i) => (
								<NavItem key={i}>{option}</NavItem>
							))}
                            <NavItem>{t('cancel_autodebit')}
								<NavLink className="linkGray-12">{t('merchant_site')}</NavLink> 
							</NavItem>
                        </Nav>
						<span className="icon-close"></span>
                    </div> */}
					{/* <Popover target='popover2' className="" placement="bottom" isOpen={this.state.amountType}  toggle={()=>this.togglePopover('amountType')}>
						<PopoverBody>
						<div className="note-popup p-0">
                        <Label>{t('Note')}:<span className="btn-closed icon-close" onClick={this.closePopover}></span></Label>
						<Nav>
							{t('type_note', {returnObjects: true}).map(({option},i) => (
								<NavItem key={i}>{option}</NavItem>
							))}
                            <NavItem>{t('cancel_autodebit')}
								<NavLink className="linkGray-12">{t('merchant_site')}</NavLink> 
							</NavItem>
                        </Nav>
						<span className="icon-close"></span>
                    	</div>
						</PopoverBody>
					</Popover> */}
					{/* <Button disabled={submitDisabled} onClick={this.props.submitForm} className="float-right">{t('pay')}</Button> */}
					<Button
                            type="submit"
                            disabled={submitDisabled }
                            onClick={this.props.submitForm}
                            className="btn mt-5"
                        >
                            <DisplayPayBtnText
                            labelName="Pay"
                            transactionDetails={transactionDetails}
                            t={t}
                            />
                        </Button>
				</div>
			</>
        )
    }
}

export default EMICardDetail;